import React from 'react';
import {withTranslation} from "react-i18next";

const SodexoPayment = ({ t, setCardData, setCompanyData }) => {

  const onChangeCardNumber = (e) => {
    const { value } = e.currentTarget;
    setCardData({cardNumber: value});
  };

  const onChangeCompanyCode = (e) => {
    const { value } = e.currentTarget;
    setCompanyData({company_code: value});
  }

  return (
    <div className={'payment-block sodexo-payment'}>
      <h2>{ t('payment.payment_type.sodexo') }</h2>
      <div className={'payment-content'} >
        <form className={'card-form'} onSubmit={ ()=> {}}>  
          <div className={'form-input required'}>
            <label htmlFor='cardNumber'>{ t('payment.card_number') }</label>
            <input type='number' name='cardNumber'  placeholder={t('payment.card_number')} onChange={ onChangeCardNumber } />
          </div>
          <div className={'form-input required'}>
            <label htmlFor='companyCode'>{ t('payment.company_code') }</label>
            <input type='number' name='companyCode' placeholder={t('payment.company_code')} onChange={ onChangeCompanyCode } />
          </div>
        </form>
      </div>
    </div>
  );
};


export default withTranslation()(SodexoPayment);
